import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "cases" };
const _hoisted_2 = { class: "info-container max-width" };
const _hoisted_3 = { class: "marquee-container" };
const _hoisted_4 = ["src"];
import { ref, computed, onMounted, nextTick } from "vue";
import post from "./components/post.vue";
import modal from "./components/modal.vue";
import { getCaseList } from "@/api/cases";
import aboutImg from "@/assets/image/about.png";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const postRef = ref();
        const modalRef = ref();
        const clickCount = ref(0);
        const caseList = ref([]);
        const currentCase = ref(null);
        const paginatedList = computed(() => {
            const pageSize = 24;
            const pages = [];
            for (let i = 0; i < caseList.value.length; i += pageSize) {
                pages.push(caseList.value.slice(i, i + pageSize));
            }
            return pages;
        });
        const displayPages = computed(() => {
            if (paginatedList.value.length === 0)
                return [];
            // 复制两份实现无缝循环
            return [...paginatedList.value, ...paginatedList.value];
        });
        const isAnimating = ref(false);
        const trackStyle = computed(() => {
            const pageCount = displayPages.value.length;
            const gapPx = 40;
            return {
                width: `calc(${pageCount * 100}% + ${pageCount * gapPx}px)`,
                "--page-width": `calc(100% / ${pageCount} - ${gapPx}px)`,
            };
        });
        const refreshData = async () => {
            try {
                const res = await getCaseList();
                caseList.value = res.data;
                if (res.data.length > 0) {
                    nextTick(() => {
                        isAnimating.value = true;
                    });
                }
            }
            catch {
                // 暂无案例
            }
        };
        onMounted(() => {
            refreshData();
        });
        const getFirstImage = (item) => {
            try {
                const images = JSON.parse(item.images || "[]");
                return images[0] || aboutImg;
            }
            catch {
                return aboutImg;
            }
        };
        const handleEdit = () => {
            const token = localStorage.getItem("token");
            if (!token) {
                return;
            }
            clickCount.value++;
            if (clickCount.value >= 2) {
                postRef.value.show();
                clickCount.value = 0;
            }
        };
        // const handleItem = (item: CaseInfo) => {
        //   currentCase.value = item;
        //   modalRef.value.show();
        // };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", {
                    class: "top-container",
                    onClick: handleEdit
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "en-title" }, "CASEDISPLAY", -1)),
                        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "cn-title" }, "案例展示", -1)),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["marquee-track", { 'marquee-animate': isAnimating.value }]),
                                style: _normalizeStyle(trackStyle.value)
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayPages.value, (items, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "grid page",
                                        key: idx
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "item",
                                                key: item.id
                                            }, [
                                                _createElementVNode("img", {
                                                    src: getFirstImage(item),
                                                    alt: "案例图片"
                                                }, null, 8, _hoisted_4)
                                            ]));
                                        }), 128))
                                    ]));
                                }), 128))
                            ], 6)
                        ])
                    ])
                ]),
                _createVNode(post, {
                    ref_key: "postRef",
                    ref: postRef,
                    onSaved: refreshData
                }, null, 512),
                _createVNode(modal, {
                    ref_key: "modalRef",
                    ref: modalRef,
                    caseData: currentCase.value
                }, null, 8, ["caseData"])
            ]));
        };
    }
});
